// extracted by mini-css-extract-plugin
module.exports =  {"titleRow":"Pt4xLjHvpBJYjCWSQbUQ","icon":"slFfb8sYCo1A8Oz1Gxs4"};